import React from "react";
import AboutUsTemplate from "@components/aboutUsPage/aboutUsTemplate";
import Layout from '@components/layout';

const IndexPage = ({ pageContext }) => (
  <Layout locale={pageContext.locale}>
    <AboutUsTemplate pageContext={pageContext} />
  </Layout>
);

export default IndexPage;
